import React, { useState } from 'react';

import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import Fab from '@mui/material/Fab';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import EmptyImage from './image.svg';

const Image = ({ value, image, style, height = 200, width = '100%', noFullScreen }) => {
	const [isFullscreen, setFullscreen] = useState(false);
	const hasImage = (value && value.link) || (image && image.link);

	return (
		<>
			<Box sx={{ marginBottom: 2, width, height, ...style }}>
				<img
					style={{ width: '100%', height: '100%', objectFit: 'scale-down', filter: !hasImage && 'saturate(0%)' }}
					src={(value || image)?.link || EmptyImage}
					onClick={() => setFullscreen(true)}
				/>
			</Box>
			<Dialog
				fullScreen
				open={!noFullScreen && isFullscreen}
				onClose={() => setFullscreen(false)}
			>
				<div style={{ width: '100%', height: '100%', backgroundColor: 'black' }}>
					<img
						style={{ width: '100%', height: '100%', objectFit: 'scale-down', filter: !hasImage && 'saturate(0%)' }}
						src={(value || image)?.link || EmptyImage}
					/>
				</div>
				<Fab
					color="primary"
					size="small"
					style={{ position: 'absolute', left: 30, top: 30 }}
					onClick={() => setFullscreen(false)}
				>
					<ArrowBackIcon />
				</Fab>
			</Dialog>
		</>
	);
};

Image.type = 'Image';

Image.spec = [{
	name: 'Image',
	key: 'Image',
	icon: 'Image',
	title: 'Image',
	category: 'layout',
	translatable: ['image'],
	fields: [{
		type: 'Upload',
		label: 'Image file',
		name: 'image',
		helperText: 'Please upload the image you want to show',
		uploadUrl: '/api/files',
		isPublic: true,
	}],
}];

export default Image;